import { TipoSurtidor } from '@shared/enums/TipoSurtidor';
import { Expendedora } from './Expendedora';
import { TanqueGeneral } from './TanqueGeneral';

export class Surtidor extends Expendedora{
    id: string;
    tanques: TanqueGeneral[];
    aforadorActual: number;
    codigoAeroplanta: string;
    tipoSurtidor: TipoSurtidor;
  }
